module.exports = __webpack_public_path__ + "img/representative.75dc652a.svg";